<template>
    <div class="cms-container mb-4">
        <ToastCMS ref="toast" />
        <!-- PREVIEW IMAGE -->
        <div v-if="showPreviewModal" class="preview-modal w-100 h-100 d-flex align-items-center justify-content-center"
            @click.self="closePreviewImage">
            <div class="d-block-align-items-center justify-content-center w-100 mx-3">
                <div class="modal-content bg-transparent position-relative border-0">
                    <button class="close-btn position-fixed text-white bg-transparent border-0"
                        @click="closePreviewImage">&times;</button>

                    <div class="d-flex justify-content-between align-items-center border-0">
                        <button v-if="previewImages.length > 1" @click="prevImage" :disabled="currentPreviewIndex === 0"
                            class="material-symbols-outlined bg-transparent border-0 text-white">
                            arrow_back_ios
                        </button>

                        <video v-if="previewIsVideo" :src="previewImages[currentPreviewIndex]" controls muted
                            style="max-width:70vw; max-height:70vh; display:block; margin:0 auto;"></video>
                        <img v-else :src="previewImages[currentPreviewIndex]" alt="Preview Image">

                        <button v-if="previewImages.length > 1" @click="nextImage"
                            :disabled="currentPreviewIndex === previewImages.length - 1"
                            class="material-symbols-outlined bg-transparent border-0 text-white">
                            arrow_forward_ios
                        </button>
                    </div>
                </div>

                <div v-if="previewImages.length > 1" class="text-center mt-3">
                    <span class="text-white">Image {{ currentPreviewIndex + 1 }} of {{ previewImages.length }}</span>
                </div>
            </div>
        </div>
        <div class="sticky-controls">
            <div class="main-header d-flex align-items-center justify-content-between px-3">
                <div class="article-header text-dark">News Articles</div>
                <button type="button" @click="addContainer"
                    class="vmc-bg-prime-4 border-0 text-white rounded px-2 py-1">Add New Article</button>
            </div>
        </div>
        <!-- BACKGROUND MEDIA -->
        <div class="px-3">
            <div class="mt-3">
                <div class="d-flex align-items-center justify-content-between w-100 my-2">
                    <div class="d-flex align-items-center justify-content-between w-100 mt-2">
                        <span class="article-header text-dark" style="font-size:16px;">
                            Background Media (MP4 or Image, Max 10MB)
                        </span>
                        <div class="d-flex align-items-center" style="gap:5px;">
                            <button type="button" @click="previewBgMedia"
                                class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                                View
                            </button>
                        </div>
                    </div>
                </div>

                <input type="file" id="upload-news-bg" accept="video/mp4,image/png,image/jpeg,image/jpg" hidden
                    @change="onBgMediaChange" />

                <div class="img-placeholder w-100 mb-2 d-flex align-items-center justify-content-center"
                    style="height:200px; border:1px solid gray; cursor:pointer; position:relative;"
                    @click="openBgFileInput">
                    <video v-if="newsBackgroundVideo" :src="newsBackgroundVideo" muted
                        style="max-width:100%; max-height:100%; object-fit:contain;"></video>
                    <img v-else-if="newsBackgroundImage" :src="newsBackgroundImage"
                        style="max-width:100%; max-height:100%; object-fit:contain;" />
                    <div v-else class="d-flex flex-column align-items-center justify-content-center text-dark">
                        <i class="material-symbols-outlined">upload</i>
                        <span>Upload Background</span>
                    </div>
                </div>

                <button type="button" @click="removeBgMedia"
                    class="vmc-bg-prime-6 w-100 text-white rounded px-2 py-1 border-0 mb-3">
                    Remove Media
                </button>
            </div>
        </div>

        <form action="" id="news">
            <div class="pb-3">
                <div class="grid-header">
                    <div class="w-100" v-for="(container, index) in containers" :key="index">
                        <div class="d-flex px-3 align-items-center justify-content-between w-100 mt-2">
                            <span class="item-number text-dark">Item # {{ index + 1 }}</span>
                            <button type="button" @click="removeContainer(index)"
                                class="px-2 py-1 vmc-bg-prime-6 border-0 text-white rounded">
                                Remove
                            </button>
                        </div>
                        <div class="input-group mt-3 px-3">
                            <input type="text" class="input-field w-100 text-dark p-2" placeholder=""
                                v-model="container.title">
                            <label class="floating-label mx-3">Title</label>
                        </div>
                        <div class="input-group mt-3 px-3">
                            <input type="text" class="input-field w-100 text-dark p-2" placeholder=""
                                v-model="container.author">
                            <label class="floating-label mx-3">Author</label>
                        </div>
                        <div class="d-flex mt-3 px-3" style="gap:10px;">
                            <div class="w-100">
                                <label class="text-dark">Category:</label>
                                <select class="w-100 text-dark" style="height:36px;" v-model="container.category">
                                    <option value="" selected disabled>--- Choose one ---</option>
                                    <option value="Company News" class="text-dark">Company News</option>
                                    <option value="Crew Updates" class="text-dark">Crew Updates</option>
                                    <option value="Government Advisories" class="text-dark">Government Advisories
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="w-100 mt-3 px-3">
                            <label class="text-dark">Description:</label>
                            <textarea rows="4" class="text-dark p-1 w-100" placeholder="Description..."
                                v-model="container.content"></textarea>
                        </div>

                        <div class="mt-3 px-3">
                            <input type="file" multiple :id="'upload-news-img-' + index"
                                accept="image/png, image/jpeg, image/jpg" hidden @change="onImageChange($event, index)">

                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <span class="text-dark">Image</span>
                                <button type="button" @click="previewImage(index)"
                                    class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                                    View
                                </button>
                            </div>
                            <div class="img-placeholder w-100 mb-2" style="border:1px solid gray;">
                                <div v-if="container.images && container.images.length"
                                    class="d-flex flex-wrap h-100 align-items-center justify-content-center"
                                    style="gap:10px;">
                                    <div v-for="(img, i) in container.images.slice(0, 4)" :key="i"
                                        style="position:relative;">
                                        <img class="img-container" :src="img">
                                        <button type="button" @click="deleteSingleImage(index, i)"
                                            class="d-flex align-items-center justify-content-center position-absolute bg-danger border-0 rounded-circle"
                                            style="top:-6px; right:-6px; width:20px; height:20px; cursor:pointer;">
                                            <span class="material-symbols-outlined text-white"
                                                style="font-size: 12px;">remove</span>
                                        </button>
                                    </div>
                                    <div @click="previewImage(index)"
                                        v-if="container.images && container.images.length > 4"
                                        class="more-image d-flex align-items-center justify-content-center bg-secondary text-white border border-gray rounded">
                                        +{{ container.images.length - 4 }} more
                                    </div>
                                </div>
                                <div v-else
                                    class="w-100 h-100 d-flex flex-column justify-content-center align-items-center"
                                    style="cursor:pointer;" @click="openFileInput(index)">
                                    <i class="material-symbols-outlined">upload</i>
                                    <span>Upload Photo</span>
                                </div>
                            </div>
                            <div class="d-flex" style="gap:10px">
                                <button type="button" @click="openFileInput(index)"
                                    class="vmc-bg-prime-4 w-100 text-white rounded px-2 py-1 border-0">
                                    Add Photo
                                </button>
                                <button type="button" @click="resetImage(index)"
                                    class="vmc-bg-prime-6 w-100 text-white rounded px-2 py-1 border-0">
                                    Remove All Photo
                                </button>
                            </div>
                        </div>
                        <hr class="px-0">
                    </div>
                </div>
            </div>
        </form>
        <div class="px-3">
            <button type="button" @click="saveAllChanges" class="vmc-bg-prime-4 text-white border-0 rounded px-3 py-1">
                Save All Changes
            </button>
        </div>
    </div>
</template>

<script>
import ToastCMS from '../ToastCMS.vue';
export default {
    name: "NewsCMS",
    components: { ToastCMS },
    data() {
        return {
            containers: [],
            originalContainers: [],
            newsBackgroundVideo: '',
            newsBackgroundImage: '',
            originalBgVideo: '',
            originalBgImage: '',
            previewImages: [],
            previewIsVideo: false,
            showPreviewModal: false,
            currentPreviewIndex: 0,
        }
    },

    async mounted() {
        window.addEventListener('keydown', this.onKeyboard);
        await this.loadFormData();
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.onKeyboard);
    },

    computed: {
        hasChanges() {
            return (
                JSON.stringify(this.containers) !== JSON.stringify(this.originalContainers) ||
                this.newsBackgroundVideo !== this.originalBgVideo ||
                this.newsBackgroundImage !== this.originalBgImage
            );
        }
    },

    methods: {
        async loadFormData() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/content?_nocache=${new Date().getTime()}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error("Failed to fetch");
                const data = await response.json();

                const articles = Array.isArray(data.newsArticles) ? data.newsArticles : [];
                this.containers = articles.map(a => ({
                    id: a.id || Date.now() + Math.random(),
                    title: a.title || '',
                    author: a.author || '',
                    category: a.category || '',
                    date: a.date || '',
                    content: a.content || '',
                    images: Array.isArray(a.images) ? [...a.images] : [],
                }));
                this.originalContainers = JSON.parse(JSON.stringify(this.containers));

                this.newsBackgroundVideo = data.newsBackgroundVideo || '';
                this.newsBackgroundImage = data.newsBackgroundImage || '';
                this.originalBgVideo = data.newsBackgroundVideo || '';
                this.originalBgImage = data.newsBackgroundImage || '';

            } catch (error) {
                console.error("Load error:", error);
                this.$refs.toast.showToast("Failed to load data.", "error");
            }
        },

        async saveAllChanges() {
            if (!this.hasChanges) {
                this.$refs.toast.showToast("Nothing to save.", "warning");
                return;
            }

            // Check if any visible container is missing required fields
            const hasEmptyFields = this.containers.some(c =>
                !c.author?.trim() ||
                !c.title?.trim() ||
                !c.category?.trim() ||
                !c.content?.trim()
            );

            if (hasEmptyFields) {
                this.$refs.toast.showToast("Author, Title, Category, and Description are required for all articles.", "error");
                return;
            }

            try {
                const token = localStorage.getItem('vmc_token');
                const payload = {
                    newsArticles: this.containers.map(c => ({
                        id: c.id,
                        title: c.title,
                        author: c.author,
                        category: c.category,
                        date: c.date,
                        content: c.content,
                        images: c.images || [],
                    })),
                    newsBackgroundVideo: this.newsBackgroundVideo,
                    newsBackgroundImage: this.newsBackgroundImage,
                };

                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/update`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        'Cache-Control': 'no-cache'
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) throw new Error("Save failed");

                this.$refs.toast.showToast("Saved all changes.", "success");
                this.originalContainers = JSON.parse(JSON.stringify(this.containers));
                this.originalBgVideo = this.newsBackgroundVideo;
                this.originalBgImage = this.newsBackgroundImage;

                setTimeout(() => { window.location.reload(); }, 1500);

            } catch (error) {
                console.error("Save error:", error);
                this.$refs.toast.showToast("Failed to save.", "error");
            }
        },

        addContainer() {
            const now = new Date();
            const date = now.toISOString().slice(0, 10);
            const time = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
            this.containers.push({
                id: Date.now(),
                title: '', author: '', category: '', date: `${date} | ${time}`, content: '', images: []
            });
            this.$refs.toast.showToast(`Article # ${this.containers.length} added`, "success");
        },

        removeContainer(index) {
            const input = document.getElementById(`upload-news-img-${index}`);
            if (input) input.value = "";
            this.containers.splice(index, 1);
            this.$refs.toast.showToast(`Article # ${index + 1} removed`, "error");
        },

        async onImageChange(e, index) {
    const files = e.target.files;
    if (!files || !files.length) return;

    if (!this.containers[index].images) {
        this.$set(this.containers[index], 'images', []);
    }

    for (const file of Array.from(files)) {
        if (file.type.startsWith("image/")) {
            const formData = new FormData();
            formData.append('image', file);

            try {
                const response = await fetch('/vmc/api/upload', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
                    },
                    body: formData
                });

                const data = await response.json();

                if (response.ok) {
                    this.containers[index].images.push(data.url);
                    this.$refs.toast.showToast("Image(s) attached", "success");
                } else {
                    console.error("Upload failed:", data.message);
                }
            } catch (error) {
                console.error("Upload error:", error);
            }
        }
    }
},

        openBgFileInput() {
            document.getElementById('upload-news-bg').click();
        },

        openFileInput(index) {
            document.getElementById(`upload-news-img-${index}`).click();
        },

        previewImage(index) {
            const imgs = this.containers[index].images;
            if (!imgs || !imgs.length) {
                this.$refs.toast.showToast("No images to view", "warning");
                return;
            }
            this.previewImages = [...imgs];
            this.previewIsVideo = false;
            this.currentPreviewIndex = 0;
            this.showPreviewModal = true;
        },

        resetImage(index) {
            const hasImage = this.containers[index].images && this.containers[index].images.length > 0;
            if (hasImage) {
                this.$refs.toast.showToast("All images removed", "error");
            } else {
                this.$refs.toast.showToast("No image attached", "warning");
            }
            this.$set(this.containers[index], 'images', []);
            const input = document.getElementById(`upload-news-img-${index}`);
            if (input) input.value = "";
        },

        deleteSingleImage(index, i) {
            this.containers[index].images.splice(i, 1);
            this.$refs.toast.showToast("Image removed", "error");
        },

        // BACKGROUND MEDIA
        async onBgMediaChange(e) {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
        this.$refs.toast.showToast("File is too large. Max 10MB.", "error");
        e.target.value = "";
        return;
    }

    const formData = new FormData();
    formData.append('image', file);

    try {
        const response = await fetch('/vmc/api/upload', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
            },
            body: formData
        });

        const data = await response.json();

        if (response.ok) {
            if (file.type === 'video/mp4') {
                this.newsBackgroundVideo = data.url;
                this.newsBackgroundImage = '';
            } else {
                this.newsBackgroundImage = data.url;
                this.newsBackgroundVideo = '';
            }
            this.$refs.toast.showToast("Background media attached", "success");
        } else {
            console.error("Upload failed:", data.message);
        }
    } catch (error) {
        console.error("Upload error:", error);
    }

    e.target.value = "";
},

        removeBgMedia() {
            if (!this.newsBackgroundVideo && !this.newsBackgroundImage) {
                this.$refs.toast.showToast("No background media to remove", "warning");
                return;
            }
            this.newsBackgroundVideo = '';
            this.newsBackgroundImage = '';
            this.$refs.toast.showToast("Background media removed", "error");
        },

        previewBgMedia() {
            if (!this.newsBackgroundVideo && !this.newsBackgroundImage) {
                this.$refs.toast.showToast("No background media to view", "warning");
                return;
            }
            if (this.newsBackgroundVideo) {
                this.previewImages = [this.newsBackgroundVideo];
                this.previewIsVideo = true;
            } else {
                this.previewImages = [this.newsBackgroundImage];
                this.previewIsVideo = false;
            }
            this.currentPreviewIndex = 0;
            this.showPreviewModal = true;
        },

        closePreviewImage() {
            this.showPreviewModal = false;
            this.previewImages = [];
            this.previewIsVideo = false;
        },

        prevImage() {
            if (this.currentPreviewIndex > 0) this.currentPreviewIndex--;
        },
        nextImage() {
            if (this.currentPreviewIndex < this.previewImages.length - 1) this.currentPreviewIndex++;
        },

        onKeyboard(e) {
            if (this.showPreviewModal) {
                if (e.key === 'ArrowRight') this.nextImage();
                else if (e.key === 'ArrowLeft') this.prevImage();
                else if (e.key === 'Escape') this.closePreviewImage();
            }
        },
    }
}
</script>

<style scoped>
.toast-container {
    position: fixed;
    width: 300px;
    top: 20px;
    right: 20px;
    z-index: 9999;
}

hr {
    border-top: 1px solid black;
}

.sticky-controls {
    position: sticky;
    z-index: 1;
    background-color: white;
}

@media (min-width: 330px) {
    .main-header {
        padding: 15px 0;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .article-header {
        font-size: 17px;
        font-weight: 600;
    }

    .item-number {
        font-size: 18px;
        font-weight: 600;
    }

    textarea {
        resize: none;
    }

    button {
        font-size: 16px;
    }

    input {
        height: 36px;
    }

    .input-group {
        position: relative;
        display: flex;
    }

    .input-field {
        border: 1px solid gray;
        border-radius: 4px !important;
        width: 100%;
        outline: none;
    }

    .floating-label {
        position: absolute;
        top: 50%;
        left: 8px;
        transform: translateY(-50%);
        color: gray;
        background-color: white;
        transition: all 0.3s ease;
        pointer-events: none;
    }

    .input-field:focus~.floating-label,
    .input-field:not(:placeholder-shown)~.floating-label {
        top: 0;
        left: 8px;
        transform: translateY(-50%);
        font-size: 12px;
    }

    .delete-btn {
        font-size: 16px;
    }

    textarea,
    input,
    select {
        font-size: 15px;
        outline: none;
    }

    .grid-header>div {
        width: 100%;
    }

    .preview-modal {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        overflow-y: hidden;
        overscroll-behavior: contain;
    }

    .img-container {
        height: 50px;
        width: 50px;
        object-fit: cover;
        border: 1px solid #ccc;
    }

    .img-placeholder {
        height: 100px;
        background-position: center;
    }

    .more-image {
        height: 50px;
        width: 50px;
        font-size: 14px;
        text-align: center;
        object-fit: cover;
        cursor: pointer;
    }

    .modal-content img {
        max-width: 70vw;
        max-height: 70vh;
        width: auto;
        height: auto;
        object-fit: contain;
        display: block;
        margin: 0 auto;
    }

    .modal-content video {
        max-width: 70vw;
        max-height: 70vh;
        display: block;
        margin: 0 auto;
    }

    .close-btn {
        top: 10px;
        right: 15px;
        font-size: 24px;
        cursor: pointer;
    }

    .sticky-controls {
        top: 60px;
    }
}

@media (min-width: 768px) {
    .img-container {
        height: 80px;
        width: 80px;
    }

    .more-image {
        height: 80px;
        width: 80px;
        font-size: 16px;
        object-fit: cover;
        border: 1px solid #ccc;
    }

    .article-header {
        font-size: 20px;
    }
}

@media (min-width: 992px) {
    .grid-header {
        display: flex;
        flex-wrap: wrap;
    }

    .grid-header>div {
        width: 50% !important;
        box-sizing: border-box;
    }

    .img-placeholder {
        height: 150px;
    }

    .modal-content img {
        max-height: 80vh;
    }
}

@media (min-width: 1200px) {
    .cms-container {
        margin-left: 310px;
        width: calc(100% - 310px);
        margin-top: 82px;
    }

    .sticky-controls {
        top: 82px;
    }
}
</style>